<template>
  <ToggleSection
    label="Sequencing Library Preparation"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['library_kit_type', 'orientation'],
        ['barcode'],
        ['source', 'strategy'],
        ['selection', 'rt_primer_type'],
        ['library_strand', 'end_bias'],
        ['is_control', 'is_single_cell'],
        ['has_plate_position'],
      ]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'SequencingLibraryPreparation',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
